import { Box, Drawer, IconButton, Theme, SxProps, Typography } from '@mui/material';
import { EasTooltip } from '../EasTooltip';
import { Close, HelpOutline } from '@mui/icons-material';
import React, { useRef, useState } from 'react';
import { EHelpButtonArticles, HELP_CENTER_ARTICLE_URLS, HELP_CENTER_ARTICLES } from './constants';

type HelpButtonProps = {
	type: EHelpButtonArticles;
	sx?: SxProps<Theme>;
};

type ZendeskFn = (...args: unknown[]) => unknown;

export const HelpButton: React.FC<HelpButtonProps> = ({ type, sx }) => {
	const [open, setOpen] = useState(false);
	const drawerContentRef = useRef<HTMLDivElement | null>(null);
	let movedWidgetFrame: HTMLIFrameElement | null = null;

	const ensureZendesk = async () => {
		const snippetId = 'ze-snippet';
		const existing = document.getElementById(snippetId);
		if (!existing) {
			const script = document.createElement('script');
			script.id = snippetId;
			script.src =
				'https://static.zdassets.com/ekr/snippet.js?key=b2f7e686-e618-409f-bc7b-0ca9fb77e040';
			script.async = true;
			document.head.appendChild(script);
		}
		let tries = 0;
		while (tries < 100) {
			const w = window as unknown as { zE?: ZendeskFn };
			if (w.zE) return w.zE;

			await new Promise<void>((resolve) => {
				setTimeout(() => resolve(), 100);
			});
			tries += 1;
		}
		return null;
	};

	const moveWidgetIntoDrawer = () => {
		try {
			const frame = document.querySelector<HTMLIFrameElement>(
				'iframe#webWidget, iframe[name="webWidget"], iframe[data-testid="web-widget"]',
			);
			if (frame && drawerContentRef.current) {
				movedWidgetFrame = frame;
				frame.style.position = 'absolute';
				frame.style.inset = '0';
				frame.style.width = '100%';
				frame.style.height = '100%';
				frame.style.border = '0';
				frame.style.maxHeight = 'none';
				(frame.style as unknown as Record<string, string>).right = 'auto';
				(frame.style as unknown as Record<string, string>).bottom = 'auto';
				drawerContentRef.current.appendChild(frame);
				return true;
			}
			return false;
		} catch {
			return false;
		}
	};

	const restoreWidgetToBody = () => {
		try {
			if (movedWidgetFrame) {
				document.body.appendChild(movedWidgetFrame);
				movedWidgetFrame = null;
			}
		} catch {
			// noop
		}
	};

	const openWidget = async () => {
		const targetId = HELP_CENTER_ARTICLES[type] ?? undefined;
		const zE = await ensureZendesk();
		if (!zE) return false;
		try {
			if (targetId) {
				zE('webWidget', 'helpCenter:article', { id: targetId });
			}
			zE('webWidget', 'open');
			setTimeout(() => {
				moveWidgetIntoDrawer();
			}, 300);
			return true;
		} catch {
			return false;
		}
	};

	const closeWidget = () => {
		const w = window as unknown as { zE?: ZendeskFn };
		if (w.zE) {
			try {
				w.zE('webWidget', 'close');
			} catch {
				// noop
			}
		}
		restoreWidgetToBody();
	};

	return (
		<>
			<EasTooltip title={`Help - ${type}`}>
				<IconButton
					color="primary"
					sx={{ fontSize: '2rem', p: 0, m: 0, ...sx }}
					onClick={() => {
						if (HELP_CENTER_ARTICLES[type]) window.open(HELP_CENTER_ARTICLE_URLS[type], '_blank');
					}}
				>
					<HelpOutline sx={{ fontSize: '2rem', p: 0, m: 0, ...sx }} />
				</IconButton>
			</EasTooltip>

			{/* <Drawer
				anchor="right"
				open={open}
				onClose={() => {
					setOpen(false);
					closeWidget();
				}}
				PaperProps={{
					sx: {
						width: 560,
						height: '100vh',
						display: 'flex',
						flexDirection: 'column',
					},
				}}
			>
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 1 }}>
					<Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
						{type}
					</Typography>
					<IconButton
						onClick={() => {
							setOpen(false);
							closeWidget();
						}}
					>
						<Close />
					</IconButton>
				</Box>
				<Box
					ref={drawerContentRef}
					sx={{ position: 'relative', flex: 1, borderTop: '1px solid #eee' }}
				/>
			</Drawer> */}
		</>
	);
};

export default HelpButton;
